import { ButtonLink, FadeIn } from "@/components/blocks";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="relative overflow-hidden bg-limed px-6 py-28 text-white sm:px-10 sm:py-40 lg:px-16">
      <div
        aria-hidden="true"
        className="absolute -right-40 -top-40 h-[34rem] w-[34rem] rounded-full bg-lime opacity-40 blur-[160px]"
      />
      <div className="relative mx-auto max-w-[1440px]">
        <FadeIn>
          <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-white/70">
            <span className="inline-block h-1.5 w-1.5 bg-white" />
            Apply
          </p>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 font-display text-[12vw] font-black uppercase leading-[0.9] tracking-tight sm:text-[8.5vw] lg:text-[7vw]">
            Real coaching happens
            <br />
            in real time.
          </h2>
        </FadeIn>
        <FadeIn delay={0.2}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg">
            Book a complimentary 20-minute movement consult to evaluate your posture and map your
            training plan — live, on camera, with a StrengthLeap coach.
          </p>
        </FadeIn>
        <FadeIn delay={0.3} className="mt-12 flex flex-wrap gap-4">
          <ButtonLink to="/start" variant="white" testid="final-cta-assessment">
            Book Your Live Video Assessment
          </ButtonLink>
          <ButtonLink to="/contact" variant="outlineCobalt" testid="final-cta-coach">
            Speak With a Coach
          </ButtonLink>
        </FadeIn>
      </div>
    </section>
  );
}
